const API_BASE = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:3847/api';

class API {
  // Track visitor
  static async trackVisitor(visitorId, path = '/', referrer = '') {
    try {
      const response = await fetch(`${API_BASE}/visitor/track`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ visitorId, path, referrer })
      });
      return await response.json();
    } catch (error) {
      console.error('Error tracking visitor:', error);
      return null;
    }
  }

  // Start game session
  static async startGame(visitorId, difficultyLevel = 'medium') {
    try {
      const response = await fetch(`${API_BASE}/game/start`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ visitorId, difficultyLevel })
      });
      return await response.json();
    } catch (error) {
      console.error('Error starting game:', error);
      return null;
    }
  }

  // End game session
  static async endGame(gameSessionId, playerScore, aiScore) {
    try {
      const response = await fetch(`${API_BASE}/game/end`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ gameSessionId, playerScore, aiScore })
      });
      return await response.json();
    } catch (error) {
      console.error('Error ending game:', error);
      return null;
    }
  }
}

export default API;
